<div class="title-container mb-2" (click)="showContent()">
    <div class=" row d-flex align-items-center">
        <div class="col-auto">
            <p [ngClass]="!isCollapse ? 'open-text': 'cloded-text'">{{title}}</p>
        </div>
        <div class="col d-flex justify-content-end">
            <i [ngClass]="!isCollapse ? 'fa-chevron-down': 'fa-chevron-up'" class="fas"></i>
        </div>
    </div>
</div>
<div *ngIf="isCollapse" [@dropdownAnimation]="isCollapse ? 'open' : 'closed'">
    <ng-content></ng-content>
</div>